import { Component, Prop } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { ApartmentDTO } from '../../../model/ApartmentDTO';

@Block() @Component
export class PageMetaApartmentBlock extends BaseBlock {
	@Prop() apartment: ApartmentDTO;

	get titleText(): string {
		let cityName = this.apartment.location.city;
		if (this.apartment.location.cityPart) {
			cityName += " - " + this.apartment.location.cityPart;
		}

		return this.getText((this.apartment.isStudio ? "page-title-studio" : "page-title-apartment"), [
			this.apartment.housingBlock.name,
			this.apartment.number,
			this.apartment.layoutLabel + (this.apartment.secondaryLayoutLabel ? ' (' + this.apartment.secondaryLayoutLabel + ')' : ''),
			cityName,
			this.apartment.location.name
		]);
	}

	get descriptionText(): string  {
		return this.getText(`page-description-${(this.apartment.isStudio ? "studio" : "apartment")}`, [
			this.apartment.housingBlock.name,
			this.apartment.number,
			this.apartment.layoutLabel + (this.apartment.secondaryLayoutLabel ? ' (' + this.apartment.secondaryLayoutLabel + ')' : ''),
			this.apartment.floor.label,
			this.apartment.innerFloorArea
		]);
	}
}

export default PageMetaApartmentBlock;
